<script lang="ts" setup>
import { computed } from 'vue'
import { useGalleryState } from '@/composables/useGalleryState'
import type { Gallery } from '@/types/Gallery'

const props = withDefaults(
  defineProps<{
    visible: boolean
  }>(),
  {}
)

const emit = defineEmits<{
  (e: 'hide'): void
}>()

const { activeSlide, gallery } = useGalleryState()

const visibleRef = computed(() => {
  return props.visible
})

const onHide = () => {
  emit('hide')
}

const imgList = computed(() => {
  const galleryObj: Gallery = gallery.value
  return galleryObj.images[activeSlide.value].sizes.lightBox.src
})
</script>

<template>
  <vue-easy-lightbox :visible="visibleRef" :imgs="imgList" @hide="onHide"></vue-easy-lightbox>
</template>
